import React, { useEffect } from "react";
/* eslint-disable jsx-a11y/label-has-associated-control */
export default function FakeStripePaymentElement(props) {
  const { onReady } = props;

  if (onReady) {
    useEffect(() => {
      onReady();
    }, []);
  }

  return (
    <>
      <div>Fake Stripe Payment Element</div>
      <label>
        Card Number
        <input name="number" type="text" />
      </label>
      <label>
        Expiry
        <input name="expiry" type="text" />
      </label>
      <label>
        CVC
        <input name="cvc" type="text" />
      </label>
      <label>
        Country
        <select name="country">
          <option disabled="" value="">
            Select
          </option>
          <option value="CA">Canada</option>
          <option value="CR">Costa Rica</option>
          <option value="GB">United Kingdom</option>
          <option value="US">United States</option>
        </select>
      </label>
      <label>
        Postal Code
        <input name="postalCode" type="text" />
      </label>
    </>
  );
}
/* eslint-enable jsx-a11y/label-has-associated-control */
